import request from '@host-panel/request';

type RequestPayload = {
  count: number;
  offset: number;
  sortBy: 'newest' | 'oldest';
};

type Response = {
  events: any[];
  total_events: number;
  spot_id: string;
};

export function fetchAllLiveBlogs({ count, offset, sortBy }: RequestPayload): Promise<Response> {
  return request(`/host-panel/live-blog/spot/events`, {
    method: 'GET',
    data: {
      count,
      offset,
      sort_by: sortBy
    }
  });
}
